import React from 'react';
import * as Ids from '@utils/ids';
import { connect } from 'react-redux';

import { createCustomWithErrorBoundaryForShellHead } from '@components/ErrorBoundary/withErrorBoundary';

import { RootState } from '../../store';
import styles from './Header.module.scss';
import OrderSearch from './components/OrderSearch';
import PoliList from './components/PoliList';
import BusinessStatus from './components/BusinessStatus';
import AcctInfo from './components/AcctInfo';
import PrintStatus from './components/PrintStatus';
import Notice from './components/Notice';

import { CustomizedShowArrType } from '../../api/define';
import Logo from './components/Logo';

interface HeaderProps {
    /** 定制化配置 */
    customizedShowArr: CustomizedShowArrType[];
}

const Header: React.FC<HeaderProps> = ({ customizedShowArr }) => {
    return (
        <div className={styles.header}>
            <Logo />
            <div className={styles.operationArea}>
                {/* 订单搜索，仅到店门店不展示搜索 */}
                {Ids.getOnlyForDaoDianAcct() === '1' ||
                customizedShowArr.includes(CustomizedShowArrType.SEARCH_BOX) ? null : (
                    <OrderSearch />
                )}
                {/* 门店列表 */}
                <PoliList />
                {/* 门店营业状态（单店） */}
                {Ids.getWmPoiId() !== '-1' &&
                !customizedShowArr.includes(CustomizedShowArrType.BUSINESS_STATE) ? (
                    <BusinessStatus />
                ) : (
                    ''
                )}
                {/* 用户信息 */}
                <AcctInfo />
                {/* 打印机状态 */}
                {customizedShowArr.includes(CustomizedShowArrType.PRINT_ICON) ? null : (
                    <PrintStatus />
                )}
                {/* 消息通知，仅到店门店不展示消息通知 */}
                {Ids.getOnlyForDaoDianAcct() === '1' ||
                customizedShowArr.includes(CustomizedShowArrType.PRINT_ICON) ? null : (
                    <Notice />
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        customizedShowArr: state.shellCommon.customizedShowArr,
    };
};

export default createCustomWithErrorBoundaryForShellHead('操作栏')(
    connect(mapStateToProps)(Header),
);
